import { WithContext, Article as ArticleSchema } from 'schema-dts';

import { Article } from 'types/models/Article';
import ContactConfig from 'types/ContactConfig';
import { getPlainTextContent } from '@templates/Description';
import resolveImageUrl from 'utils/resolveImageUrl';
import map from 'utils/map';

type Data = Pick<Article, 'abstract' | 'createdAt' | 'updatedAt' | 'image' | 'seoData' | 'tags'>;

export const getArticleStructuredData = (
  { abstract, createdAt, updatedAt, image, seoData, tags }: Data,
  { appUrl, contact, companyLogoUrl }: { appUrl: string; contact: ContactConfig; companyLogoUrl?: string }
): WithContext<ArticleSchema> => {
  const plainTextDescription = getPlainTextContent(seoData?.description);
  const imageUrl = resolveImageUrl(
    {
      preset: 'og',
      extension: image.extension,
      name: image.basename,
      description: 'cover',
      productName: seoData?.header,
    },
    { appUrl }
  );
  const structuredData: WithContext<ArticleSchema> = {
    '@context': 'https://schema.org',
    '@type': 'TechArticle',
    headline: seoData?.header,
    abstract: abstract || undefined,
    articleBody: plainTextDescription,
    dateCreated: createdAt,
    datePublished: createdAt,
    dateModified: updatedAt,
    creativeWorkStatus: 'Published',
    inLanguage: 'pl-PL',
    isAccessibleForFree: true,
    keywords: map(tags, 'articleTag.name'),
    image: imageUrl,
    author: {
      '@type': 'Organization',
      name: contact.name,
    },
    publisher: {
      '@type': 'Organization',
      name: contact.name,
      url: contact.companyUrl,
      logo: companyLogoUrl,
    },
  };
  return structuredData;
};
